//server
// const API_URL = "https://test.discussion.leadershipedge.team/backend/web/api";
//local
const API_URL = "http://localhost/le-team/backend/web/api";
export default API_URL;
